export const TASK_CARD_BRAND_LOGO = '/assets/tasks/tasks-card/brand-logo.webp'

/** Fictional brand logo on Coming soon task cards */
export const TASK_CARD_DEMO_BRAND_LOGO = '/assets/ball.png'

export const TASK_CARD_SOCIAL_TIKTOK_SRC =
  '/assets/tasks/tasks-card/tiktok.webp'
export const TASK_CARD_SOCIAL_INSTAGRAM_SRC =
  '/assets/tasks/tasks-card/instagram.webp'
export const TASK_CARD_SOCIAL_YOUTUBE_SRC =
  '/assets/tasks/tasks-card/youtube.webp'
export const TASK_CARD_SOCIAL_X_SRC = '/assets/tasks/tasks-card/x_logo.png'
export const TASK_CARD_SOCIAL_FACEBOOK_SRC =
  '/assets/tasks/tasks-card/facebook.webp'

export const TASK_CARD_SOCIAL_SRC = {
  tiktok: TASK_CARD_SOCIAL_TIKTOK_SRC,
  instagram: TASK_CARD_SOCIAL_INSTAGRAM_SRC,
  youtube: TASK_CARD_SOCIAL_YOUTUBE_SRC,
  x: TASK_CARD_SOCIAL_X_SRC,
  facebook: TASK_CARD_SOCIAL_FACEBOOK_SRC
} as const

export type TaskCardSocialPlatform = keyof typeof TASK_CARD_SOCIAL_SRC
